import { createUpdater } from './createUpdater';
import { updaterStore as createUpdaterStore } from './updaterStore';

export const combineUpdaters = (updaters, deps = {}) => {
  const updaterStore = createUpdaterStore();

  return updaters.map(
    (updater) => updater && createUpdater(updater(deps), updaterStore),
  );
};
